import React from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';

import polaroid from '../../assets/images/about_me_gif.gif';
import paintbrushHero from '../../assets/images/paintbrush_about_hero.png';
import wigglyUnderline from '../../assets/images/about_underline.png';
import IconCurious from '../../assets/icons/IconCurious.png';
import IconImpact from '../../assets/icons/IconImpact.png';
import IconHumble from '../../assets/icons/IconHumble.png';
import IconEquity from '../../assets/icons/IconEquity.png';

import style from './about.module.scss';

const VALUES = [
  {
    key: 'curious',
    title: 'Stay curious, keep learning',
    body:
      "When we stop learning, we  start dying. Dramatic, yes but also true. I am committed to my professional and personal growth and learn so much from my colleagues and the users I serve.",
    Icon: IconCurious,
  },
  {
    key: 'impact',
    title: 'Create a positive impact',
    body:
      'As a leader, manager and colleague I believe that respect is fundamental to thriving relationships. Humility leads to strong, kinder communication and that is key to success.',
    Icon: IconImpact,
  },
  {
    key: 'humble',
    title: 'Remain humble',
    body:
      'As a leader, manager and colleague I believe that respect is fundamental to thriving relationships. Humility leads to strong, kinder communication and that is key to success.',
    Icon: IconHumble,
  },
  {
    key: 'equity',
    title: 'Equity, Inclusion & Accessibility',
    body:
      'As a leader, manager and colleague I believe that respect is fundamental to thriving relationships. Humility leads to strong, kinder communication and that is key to success.',
    Icon: IconEquity,
  },
];

export default function AboutPage() {
  React.useEffect(() => {
    window.scrollTo({ top: 0 });
    ReactGA.pageview(window.location.pathname + window.location.search, null, 'about');
  }, []);

  return (
    <main className={style.page}>
      <section className={style.hero} aria-labelledby="about-name">
        <div className={style.heroInner}>
          <div className={style.photoCol}>
            <img
              src={polaroid}
              alt="Kyra Berman-Gestring, polaroid-style photos"
              className={style.photoMain}
            />
          </div>
          <div className={style.textCol}>
            <div className={style.nameRow}>
              <h1 id="about-name" className={style.name}>
                Kyra Berman-Gestring
              </h1>
              <p className={style.pronouns}>(she/her)</p>
            </div>
            <div>
              <p className={style.body}>
                I’m a Product Designer (UI/UX) who cares deeply about inclusivity and accessibility. I see technology as
                a powerful tool and a responsibility. My work is rooted in curiosity and empathy, diving into complex
                spaces to create data-informed designs that honor the diversity of human experience.
              </p>
              <p className={style.body}>
                As a Designer/Researcher, I’ve led projects from zero to one and helped evolve existing products. I’ve
                owned everything from research and strategy to end-to-end design execution. I’m especially drawn to
                mission-driven work, and have had the chance to design across industries including civic tech,
                healthcare, education, social media, climate tech, and non profits—on both web and mobile platforms.
              </p>
              <p className={style.body}>If any of this resonates, I’d love to connect; feel free to reach out!</p>
            </div>
            <div id="contact" className={style.ctaRow}>
              <a className={style.cta} href="mailto:kbermangestring@gmail.com">
                Email Me
              </a>
              <Link className={style.cta} to="/resume">
                Resume
              </Link>
            </div>
          </div>
        </div>
      </section>

      <div className={style.paintbrushBand} aria-hidden>
        <img
          src={paintbrushHero}
          alt=""
          className={style.paintbrushImg}
        />
      </div>

      <section id="values" className={style.values} aria-labelledby="values-heading">
        <div className={style.valuesHeader}>
          <h2 id="values-heading" className={style.valuesTitle}>
            My Design Values
          </h2>
          <img src={wigglyUnderline} alt="" className={style.valuesUnderline} />
        </div>
        <div className={style.valuesGrid}>
          {VALUES.map(({ key, title, body, Icon }) => (
            <div key={key} className={style.valueRow}>
              <div className={style.valueIcon}>
                  <img src={Icon} alt={title} className={style.valueIconSvg} />
              </div>
              <div className={style.valueText}>
                <h3 className={style.valueHeading}>{title}</h3>
                <p className={style.valueBody}>{body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
